import React from 'react'
import { router, usePage } from '@inertiajs/react'
import {
  Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Chip,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, cost_categories = [] }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  return (
    <Box>
      <PageHeader
        title="Kostenkategorien"
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Kostenkategorien' },
        ]}
        actions={
          <Button variant="contained" size="small" startIcon={<AddIcon />}
            onClick={() => router.visit(`${basePath}/cost_categories/new`)}
            data-testid="new-cost-category-btn">
            Neue Kategorie
          </Button>
        }
      />

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Gruppe</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Verteilschlüssel</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Umlagefähig</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Heizungskosten</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Position</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cost_categories.map((cc) => (
              <TableRow key={cc.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`${basePath}/cost_categories/${cc.id}`)}
                data-testid={`cost-category-row-${cc.id}`}>
                <TableCell>{cc.name}</TableCell>
                <TableCell>{cc.group || '–'}</TableCell>
                <TableCell>{cc.distribution_key_name || '–'}</TableCell>
                <TableCell>
                  <Chip size="small" label={cc.allocatable ? 'Ja' : 'Nein'}
                    color={cc.allocatable ? 'success' : 'default'} variant="outlined" />
                </TableCell>
                <TableCell>
                  <Chip size="small" label={cc.heating_related ? 'Ja' : 'Nein'}
                    color={cc.heating_related ? 'warning' : 'default'} variant="outlined" />
                </TableCell>
                <TableCell align="right">{cc.position || '–'}</TableCell>
              </TableRow>
            ))}
            {cost_categories.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4, color: 'text.secondary' }}>
                  Keine Kostenkategorien vorhanden
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
